import CollectionFiltering from '../components/CollectionFiltering'
import CollectionSuggestion from '../components/CollectionSuggestion'
import CollectionViewType from '../components/CollectionViewType'

export default class Collection {
    constructor() {
        new CollectionViewType()
        new CollectionFiltering()
        new CollectionSuggestion()
    }
}
